'use strict';

var promoGalp = function () {
  var discount = 7000,
      _getDiscount = function _getDiscount() {
    return discount;
  };

  var subOrigin1 = 'nissangalp',
      subOrigin2 = 'galpnissan';

  var existsGalp = void 0,
      subOrigin = void 0;

  var _setGalp = function _setGalp(value) {
    return existsGalp = value;
  },
      _getGalp = function _getGalp() {
    return existsGalp;
  },
      _setSubOrigin = function _setSubOrigin(value) {
    return subOrigin = value;
  },
      _getSubOrigin = function _getSubOrigin() {
    return subOrigin;
  };

  var _detectPromoGalp = function _detectPromoGalp() {
    var galpParam = utils.getUrlParameter('galp');
    if (typeof galpParam !== 'undefined' && galpParam === 'true') {
      sessionStorage.galp = 'true';
      _setGalp(true);
    } else if (typeof sessionStorage.galp !== 'undefined' && sessionStorage.galp === 'true') {
      _setGalp(true);
    } else {
      _setGalp(false);
    }
  };

  var _validateSubOrigin = function _validateSubOrigin(str) {
    if (str === subOrigin1 || str === subOrigin2) {
      return true;
    } else {
      return false;
    }
  };

  var _detectSubOrigin = function _detectSubOrigin() {
    var param = utils.getUrlParameter('suborigin');
    if (typeof param !== 'undefined' && _validateSubOrigin(param)) {
      sessionStorage.suborigin = param;
      _setSubOrigin(param);
    } else if (typeof sessionStorage.suborigin !== 'undefined') {
      _setSubOrigin(sessionStorage.suborigin);
    }
  };

  var _mustApplyDiscount = function _mustApplyDiscount() {
    return _getGalp() === true && _validateSubOrigin(_getSubOrigin()) && typeof currentModel !== 'undefined' && currentModel.toLowerCase() === 'leaf' ? true : false;
  };

  var _getPrice = function _getPrice(value) {
    return value - _getDiscount();
  };

  var _applyDiscount = function _applyDiscount(array, force) {
    console.log('array', array);

    var isPromo = force === true ? _getGalp() : _mustApplyDiscount();

    console.log('isPromo', isPromo);

    if (isPromo) {
      var newArray = array.map(function (elem) {
        var modelName = void 0;
        if (typeof elem.vehicle.vmodelo !== 'undefined') {
          modelName = elem.vehicle.vmodelo;
        }
        if (typeof elem.vehicle.vdisplayModelo !== 'undefined') {
          modelName = elem.vehicle.vdisplayModelo;
        }
        console.log('modelname', modelName);
        if (modelName.toLowerCase() === 'leaf') {
          elem.prices.precioFinanciacion = _getPrice(elem.prices.precioFinanciacion);

          if (typeof elem.prices.precioDtoMostrarFinanClasica !== 'undefined') {
            var newPrice = elem.prices.precioDtoMostrarFinanClasica + _getDiscount();
            elem.prices.precioDtoMostrarFinanClasica = newPrice;
          }

          if (typeof elem.prices.precioDtoMostrarFinanMP3D !== 'undefined') {
            var _newPrice = elem.prices.precioDtoMostrarFinanMP3D + _getDiscount();
            elem.prices.precioDtoMostrarFinanMP3D = _newPrice;
          }
        }
        return elem;
      });
      console.log('newArray', newArray);
      return newArray;
    } else {
      return array;
    }
  };

  var _init = function _init() {
    _detectPromoGalp();
    _detectSubOrigin();
    console.log('promoGalp exists?', _getGalp());
    console.log('Can we apply Galp discount?', _mustApplyDiscount());
  };

  return {
    init: _init,
    mustApplyDiscount: _mustApplyDiscount,
    applyDiscount: _applyDiscount,
    getSubOrigin: _getSubOrigin,
    getPrice: _getPrice
  };
}();